import React, { FC } from 'react';
import Link from 'next/link';
import styles from '#components/teasers/poster-teaser/PosterTeaser.module.scss';
import { ITeaserRenderer } from '#components/lists/horizontal-scroll-list/HorizontalScrollList';
import { getRoute } from '#utils';
import MediaboxHOC from '#components/hocs/MediaboxHOC';
import { ImageRendererTypes } from '#config';
import { Microphone } from '#components/icons';
import {
  ContentType,
  LivestreamState,
  Teaser,
} from '#types/generated/graphql-types';
import LiveIndicator from '#components/feedback/live-indicator/LiveIndicator';
import useTranslation from 'next-translate/useTranslation';

interface Props extends ITeaserRenderer {
  teaserDataRaw: Teaser;
}

const PosterTeaser: FC<Props> = ({
  teaserDataRaw,
  onMouseEnter,
  onMouseLeave,
}) => {
  const { t } = useTranslation();
  const handleMouseEnter = (event) => {
    onMouseEnter?.(event, teaserDataRaw);
  };

  return (
    <Link href={getRoute(teaserDataRaw, t) || ''}>
      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
      <div
        onMouseEnter={handleMouseEnter}
        onMouseLeave={onMouseLeave}
        className="tw-relative tw-aspect-[3/4] tw-w-full tw-h-full tw-bg-gradient-to-b tw-from-[#202b41] tw-to-[#142236] tw-rounded-lg tw-overflow-hidden tw-cursor-pointer tw-text-accent hover:tw-text-white"
        title={teaserDataRaw.title}
      >
        <MediaboxHOC
          data={teaserDataRaw}
          imageRenderer={ImageRendererTypes.PosterTeaser}
        />

        {teaserDataRaw.__typename === 'Media' &&
          teaserDataRaw?.details?.streamState === LivestreamState.Live && (
            <LiveIndicator classes="tw-absolute tw-top-4 tw-left-4" />
          )}

        {teaserDataRaw.contentType === ContentType.Audio && (
          <div className={styles.audioIcon}>
            <Microphone color="inherit" size={16} />
          </div>
        )}
      </div>
    </Link>
  );
};

export default PosterTeaser;
